export const version = "wordlists/5.2.0";
